import {Box, Container, Stack, styled} from "@mui/material";
import {tabletCssScreen} from "@/utils/themeCssBreakpoints";

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
`;

export const FlexBoxFullWidth = styled(FlexBox)`
  width: 100%;
`

export const FlexSpaceBetween = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;
`;

export const FlexColumn = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
`;

export const ImgBox = styled(Box)`
  & svg, img {
    width: 100%;
    height: 100%;
    overflow-y: visible;
    overflow-x: visible;
  }
`;

export const MainContainer = styled(Container)`
  max-width: 134rem;
  width: 90%;
  height: 100%;
  padding: 6.4rem 0;

  ${tabletCssScreen} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const BoxShadowStack = styled(Stack)`
  width: 100%;
  height: 100%;
  border-radius: 29px;
  box-shadow: 0 9px 14px 0 rgba(122, 139, 180, 0.1), 0 2px 4px 0 rgba(87, 57, 119, 0.08);
  align-items: center;
  justify-content: center;
`